(() => {
  if (typeof vehicleSearchContext === 'undefined') return;

  const onReady = (callback) => {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
    } else {
      callback();
    }
  };

  const normalizeToTokens = (value) => {
    if (!value) return [];
    const normalized = value
      .toString()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase();

    return normalized.split(/[^a-z0-9]+/).filter(Boolean);
  };

  const buildVehicleMatchers = (carData) => {
    if (!carData) return null;

    const toTokenSet = (...values) => {
      const tokens = [];
      values.forEach((value) => {
        tokens.push(...normalizeToTokens(value));
      });
      return Array.from(new Set(tokens));
    };

    const brandTokens = toTokenSet(carData.brand);

    const coreTokens = toTokenSet(
      carData.model,
      carData.version,
      carData.generation
    );

    if (!coreTokens.length && carData.bodytype) {
      coreTokens.push(...normalizeToTokens(carData.bodytype));
    }

    if (!brandTokens.length && !coreTokens.length) return null;

    return {
      brandTokens,
      coreTokens
    };
  };

  const collectProductTokens = (item) => {
    const tokens = new Set();
    const anchor = item?.querySelector('a');

    if (anchor) {
      if (anchor.pathname) {
        const handle = anchor.pathname.split('/').pop();
        normalizeToTokens(handle).forEach((token) => tokens.add(token));
      }

      normalizeToTokens(anchor.textContent).forEach((token) => tokens.add(token));
    }

    normalizeToTokens(item?.textContent).forEach((token) => tokens.add(token));

    return Array.from(tokens);
  };

  const matchesVehicle = (item, matchers) => {
    if (!item || !matchers) return true;
    const { brandTokens = [], coreTokens = [] } = matchers;
    if (!brandTokens.length) return true;

    const productTokens = collectProductTokens(item);
    if (!productTokens.length) return false;

    const tokenSet = new Set(productTokens);

    const hasBrand = brandTokens.some((token) => tokenSet.has(token));
    if (!hasBrand) return false;

    if (!coreTokens.length) return true;
    return coreTokens.some((token) => tokenSet.has(token));
  };

  const formatWithCar = (template = '', carName = '') => template.replace('__CAR__', carName);

  const getTranslations = (container) => {
    const { dataset = {} } = container || {};
    const required = [
      'vehicleFilterNoResults',
      'vehicleFilterNoResultsCar',
      'vehicleFilterFiltering',
      'vehicleFilterFilteringCar'
    ];

    const hasAll = required.every((key) => typeof dataset[key] === 'string' && dataset[key].length > 0);
    if (!hasAll) return null;

    return {
      noResults: dataset.vehicleFilterNoResults,
      noResultsWithCar: dataset.vehicleFilterNoResultsCar,
      filtering: dataset.vehicleFilterFiltering,
      filteringWithCar: dataset.vehicleFilterFilteringCar
    };
  };

  const applyVehicleFilterToSearchResults = (state) => {
    if (!state?.filterEnabled || !state.selectedCarData) return;

    const matchers = buildVehicleMatchers(state.selectedCarData);
    if (!matchers) return;

    const gridContainer = document.getElementById('ProductGridContainer');
    if (!gridContainer) return;

    const translations = getTranslations(gridContainer);
    if (!translations) return;
    const gridItems = gridContainer.querySelectorAll('.grid__item');
    if (!gridItems.length) return;

    let matchCount = 0;
    gridItems.forEach((item) => {
      if (matchesVehicle(item, matchers)) {
        matchCount += 1;
      } else {
        item.style.display = 'none';
      }
    });

    const existingIndicator = gridContainer.querySelector('.vehicle-filter-indicator');
    if (existingIndicator) {
      existingIndicator.remove();
    }

    const indicator = document.createElement('div');
    indicator.className = 'vehicle-filter-indicator';

    const carName = state.selectedCar || '';
    const hasCarName = Boolean(carName);

    if (matchCount === 0) {
      indicator.textContent = hasCarName
        ? formatWithCar(translations.noResultsWithCar, carName)
        : translations.noResults;

      const resultsWrapper = gridContainer.querySelector('.template-search__results');
      if (resultsWrapper) {
        resultsWrapper.style.display = 'none';
      }
    } else {
      indicator.textContent = hasCarName
        ? formatWithCar(translations.filteringWithCar, carName)
        : translations.filtering;
    }

    gridContainer.prepend(indicator);
  };

  onReady(() => {
    vehicleSearchContext.init().then((state) => {
      applyVehicleFilterToSearchResults(state);
    });
  });
})();
